<div id = "megaContainer">
  <div id = "showFeatureDataContainer" cdkDrag>

    <div id = "controlsContainer">
      <!--
      <canvas id = "switchDisplayMode"
        width="32"
        height="26"
        (click) = "switchDisplayMode(1)"
        matTooltip = "{{mobileOrNotTooltip}}"
        matTooltipPosition = "above"
        matTooltipClass = "tooltipStyle"
      ></canvas>
      -->
      <button class="closeBtn closeBtnShowFeature" (click) = "closeShowFeatureData(); displayService.clearFeaturesByCameFrom('click');">
        <mat-icon>close</mat-icon>
      </button>

      <div id = "tabsContainer">
        @for (table of propertiesData; track table; let i = $index) {
          <h5 (click) = tableVisibility(table.tabHeader)
            class = "tabs"
            [style.backgroundColor] = "i === 0 ? gudnaBlar : gudnaLettari"
            [style.color] = "i === 0 ? 'white' : 'black'"
            >
            {{table.tabHeader}}
          </h5>
        }
      </div>

    </div>


    <div id = tablesContainer>
      @for (table of propertiesData; track table; let i = $index) {
        <div>
          <mat-table [dataSource] = "table.values"
            id = "{{table.tabHeader}}"
            class = "showFeatureTable"
            [style.display] = "i === 0 ? 'block' : 'none'"
            >
            @for (headerVal of table.headers; track headerVal; let i = $index) {
              <div>
                <div matColumnDef = "{{table.columnKeys[i]}}">
                  <mat-header-cell *matHeaderCellDef>{{headerVal}}</mat-header-cell>
                  <mat-cell *matCellDef = "let place"
                    matTooltip = "{{place[table.columnKeys[i]]}}"
                    [matTooltipDisabled] = "disableTooltip(place[table.columnKeys[i]]) || isMobile"
                    matTooltipClass = "tooltipStyle"
                    matTooltipPosition = "above"
                    >
                    <span class = "mobileHeader">{{headerVal}}</span>
                    <!--<span>{{place[table.columnKeys[i]]}}</span>-->
                    @switch (table.columnKeys[i]) {
                      @case ('editButtonColumn') {
                        <div (click) = "goToEditFeature(place)">
                          <mat-icon class="drawFeatureIcon" matTooltipClass="tooltipStyle" matTooltip="{{selText.editRecord}}">edit</mat-icon>
                        </div>
                      }
                      @default {
                        <app-content-decider
                          class = "contentDecider"
                          [content] = "place[table.columnKeys[i]] ?? ''"
                          key = "{{table.columnKeys[i]}}"
                          layerID = "{{table.layerID}}"
                          [header] = "headerVal"
                          [selText] = "selText"
                          [lang] = "lang"
                        ></app-content-decider>
                      }
                    }
                  </mat-cell>
                </div>
              </div>
            }
            <mat-header-row *matHeaderRowDef = "table.columnKeys; sticky: true" cdkDragHandle></mat-header-row>
            <mat-row *matRowDef="let row; index as i; columns: table.columnKeys"
              (click)="displayFeature(row, table.layerID, 'click')"
              >
            </mat-row>
            <!--
            (mouseenter)="displayFeature(row, table.layerID)"
            (mouseenter)="selectedRow = row"
            (mouseleave)="selectedRows.includes(row) ? null : displayService.clearLatestFeature()"
            (click)="selectedRows.push(row); selectedFeature = row;"
            -->
          </mat-table>
        </div>
      }
    </div>
  </div>
</div>
